/**
 * Timeouts de rede (ms), num único lugar em vez de números mágicos espalhados.
 */
export const TIMEOUT_MS = {
    /** Cliente HTTP (axios) padrão. */
    httpClient: 15_000,
    /** Chamadas ao BFF de auth e do BFF/proxy para a nest (login/refresh/etc.). */
    bffAuth: 10_000,
    /** Passagem de dados pelo proxy /api/nest (payloads maiores). */
    nestProxy: 20_000,
} as const;
